import {
    Configurations,
    ImageConfiguration,
    Stops,
} from '@features/lazy-image/components/lazy-picture/lazy-picture.component';
import { GroupDepartureSummaryFeaturedImage } from '@generated/openapi/model/groupDepartureSummaryFeaturedImage';

export const FeaturedImageAspect = {
    SQUARE: 'square',
    LANDSCAPE: 'landscape',
    BANNER: 'banner',
} as const;

export type FeaturedImageAspect =
    (typeof FeaturedImageAspect)[keyof typeof FeaturedImageAspect];

export type FeaturedImageStops = Partial<Record<Stops, FeaturedImageAspect>>;

function aspectSource(
    image: GroupDepartureSummaryFeaturedImage,
    aspect: FeaturedImageAspect
): ImageConfiguration {
    return { src: image[aspect] ?? '', src2x: image[`${aspect}_2x`] };
}

/**
 * Builds a LazyPicture configuration from a Django featured-image rendition set,
 * choosing an aspect per breakpoint. Returns null when no image is available so
 * callers can skip rendering. Alt text is supplied via LazyPicture's `alt` input.
 */
export function featuredImageConfiguration(
    image: GroupDepartureSummaryFeaturedImage | null | undefined,
    stops: FeaturedImageStops
): Configurations | null {
    if (!image) {
        return null;
    }
    return Object.fromEntries(
        Object.entries(stops).map(([stop, aspect]) => [
            stop,
            aspectSource(image, aspect),
        ])
    );
}
